import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import LoginForm from '../../components/loginForm/loginForm';
import BackButton from '../../components/backButton/backButton';

import './login.less';

const Login = () => (
  <Container className="register-page page-container">
    <BackButton to="/" />
    <div className="title-wrapper">
      <Typography variant="h3">
        Logowanie
      </Typography>
    </div>
    <Paper className="paper-box">
      <Container>
        <LoginForm />
      </Container>
    </Paper>
  </Container>
);

export default Login;
